import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { map, of } from 'rxjs';
import { GetDecodedToken } from 'libs/core/src/lib/utils/token-decode';
import { RepresentativeService } from 'libs/core/src/lib/services/representative.service';
import { SystemUserRole } from '@inshuwa-client/models';

export const resolveRepresentative = () => {
  const representativeService = inject(RepresentativeService);
  const decoded = GetDecodedToken();

  if (!decoded) {
    inject(Router).navigate(['/'], { replaceUrl: true });
    return of(false);
  }

  const { id, role } = decoded;

  if (
    role.toLowerCase() === SystemUserRole.AgentRepresentative.toLowerCase() ||
    role.toLowerCase() === SystemUserRole.AdminAgentRepresentative.toLowerCase()
  ) {
    return representativeService.getAgentRepresentativeById(Number(id)).pipe(
      map((value) => {
        localStorage.setItem(
          SystemUserRole.AgentRepresentative,
          JSON.stringify(value),
        );
        return true;
      }),
    );
  }

  return of(false);
};
